import moment from "moment";
import { FunctionComponent } from "react";
import { useOrderCreateCtx } from "../../../../../context_providers/order_create_context";
import { UTCToLocalDate } from "../../../../../utils/date_util";
import {
  orderCategories,
  OrderStatus,
  OrderType,
  sale_type,
} from "../../../../../utils/enums";
import EmployeeSearchWidget from "../../../../new_components/emp_search_widget";
import { LeadSegment } from "../../../../../context_providers/auth/user_model";

interface OrderDetailSectionProps {}

const OrderDetailSection: FunctionComponent<OrderDetailSectionProps> = () => {
  const { order, setOrder, user } = useOrderCreateCtx();

  return (
    <>
      <h3 className="font-semibold mt-5">Order Details</h3>
      <div className=" bg-white shadow rounded-md text-sm p-5">
        <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 gap-x-10 gap-y-5">
          <div className="grid grid-cols-1   items-center">
            <label htmlFor="order-create-detail-order-id">
              <span className="text-base text-red-500">*</span> Order ID
            </label>
            <input
              disabled={true}
              type="text"
              id="order-create-detail-order-id"
              className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none "
              value={order.order_id}
            />
          </div>
          <div className="grid grid-cols-1 items-center">
            <label htmlFor="order-create-detail-order-date">
              {" "}
              <span className="text-base text-red-500">*</span>Date
            </label>
            <input
              className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none"
              id="order-create-detail-order-date"
              type="datetime-local"
              name="orderDate"
              required
              value={moment(order.order_date).format("YYYY-MM-DD HH:mm:ss")}
              onChange={(e) => {
                const date = new Date(e.target.value);

                setOrder((o) => ({
                  ...o!,
                  order_date: date,
                }));
              }}
            />
          </div>
          <div className="grid grid-cols-1 items-center">
            <label htmlFor="order-create-detail-type">
              {" "}
              <span className="text-base text-red-500">*</span>Type
            </label>
            <select
              id="order-create-detail-type"
              name="type"
              className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none"
              required
              value={order.type}
              onChange={(e) => {
                setOrder((o) => ({ ...o!, type: e.target.value }));
              }}
            >
              {Object.values(OrderType).map((type, i) => (
                <option value={type} key={i}>
                  {type}
                </option>
              ))}
            </select>
          </div>{" "}
          <div className="grid grid-cols-1 items-center">
            <label htmlFor="order-create-detail-status">
              {" "}
              <span className="text-base text-red-500">*</span>Status
            </label>
            <select
              name=""
              id="order-create-detail-status"
              className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none"
              value={order.status}
              onChange={(e) => {
                setOrder((o) => ({ ...o!, status: e.target.value }));
              }}
            >
              <option value="" hidden>
                Select ...
              </option>
              {Object.values(OrderStatus).map((item, i) => (
                <option key={i} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
          <div className="grid grid-cols-1 items-center">
            <label htmlFor="order-create-detail-sales-person">
              {" "}
              <span className="text-base text-red-500">*</span>Sales person
            </label>
            <div className="col-span-2  rounded bg-gray-100 focus:outline-none">
              {user?.additional_customer_details?.sales_person ? (
                <input
                  disabled={true}
                  type="text"
                  id="order-create-detail-sales-person"
                  className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none "
                  value={user?.additional_customer_details?.sales_person}
                />
              ) : (
                <EmployeeSearchWidget
                  id="order-create-detail-sales-person"
                  withBtn={false}
                  disabled={false}
                  placeholder="Select"
                  emp={
                    order.sales_person_id
                      ? {
                          uid: order.sales_person_id!,
                          name: order.sales_person_name!,
                        }
                      : undefined
                  }
                  onSelect={(emp) => {
                    const name = (emp.first_name + " " + emp.last_name).trim();
                    setOrder((o) => ({
                      ...o!,
                      sales_person_id: emp.uid,
                      sales_person_name: name,
                    }));
                  }}
                />
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 items-center">
            <label htmlFor="order-create-detail-relationship-manager">
              {" "}
              <span className="text-base text-red-500">*</span>Relationship Mgr
              1
            </label>
            <div className="col-span-2  rounded bg-gray-100 focus:outline-none">
              {user?.additional_customer_details?.relationship_manager ? (
                <input
                  disabled={true}
                  type="text"
                  id="order-create-detail-relationship-manager"
                  className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none "
                  value={
                    user?.additional_customer_details?.relationship_manager
                  }
                />
              ) : (
                <EmployeeSearchWidget
                  id="order-create-detail-relationship-manager"
                  withBtn={false}
                  disabled={false}
                  placeholder="Select"
                  emp={
                    order.rm_uid
                      ? {
                          uid: order.rm_uid!,
                          name: order.rm_name!,
                        }
                      : undefined
                  }
                  onSelect={(emp) => {
                    const name = (emp.first_name + " " + emp.last_name).trim();
                    setOrder((o) => ({
                      ...o!,
                      rm_uid: emp.uid,
                      rm_name: name,
                    }));
                  }}
                />
              )}
            </div>{" "}
          </div>
          <div className="grid grid-cols-1 items-center">
            <label htmlFor="order-create-detail-category">Category</label>
            <select
              name=""
              id="order-create-detail-category"
              className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none"
              value={order.category}
              onChange={(e) => {
                setOrder((o) => ({ ...o!, category: e.target.value }));
              }}
            >
              <option value="" hidden>
                Select ...
              </option>
              {orderCategories.map((src, i) => (
                <option value={src} key={i}>
                  {src}
                </option>
              ))}
            </select>
          </div>
          <div className="grid grid-cols-1 items-center">
            <label htmlFor="order-create-detail-segment">
              <span className="text-base text-red-500">*</span>Lead segment
            </label>
            {user?.additional_customer_details?.lead_segment ? (
              <input
                type="text"
                id="order-create-detail-segment"
                readOnly
                className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none"
                value={order.segment || ""}
                placeholder="Select ..."
              />
            ) : (
              <select
                name=""
                id="order-create-detail-segment"
                className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none"
                value={order.segment}
                onChange={(e) => {
                  setOrder((o) => ({ ...o!, segment: e.target.value }));
                }}
              >
                <option value="" hidden>
                  Select ...
                </option>
                {Object.values(LeadSegment).map((src, i) => (
                  <option value={src} key={i}>
                    {src}
                  </option>
                ))}
              </select>
            )}
          </div>
          <div className="grid grid-cols-1 items-center">
            <label htmlFor="order-create-detail-sale-type">
              <span className="text-base text-red-500">*</span>Sales type
            </label>
            <select
              name=""
              id="order-create-detail-sale-type"
              className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none"
              value={order.sale_type}
              onChange={(e) => {
                setOrder((o) => ({ ...o!, sale_type: e.target.value }));
              }}
            >
              <option value="" hidden>
                Select ...
              </option>
              {sale_type.sort().map((src, i) => (
                <option value={src} key={i}>
                  {src}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <h3 className="font-semibold mt-5">Remarks</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 bg-white shadow rounded-md text-sm p-5 gap-x-10 gap-y-5 ">
        <div className="">
          <div className=" mb-1 font-semibold text-xs">Survey date</div>
          <input
            className={`w-full text-xs  px-3 py-2  bg-gray-100 rounded focus:outline-none`}
            id="order-create-detail-survey-date"
            type="date"
            name="survey_date"
            required
            value={
              order.survey_date &&
              moment(order.survey_date).format("YYYY-MM-DD")
            }
            onChange={(e) => {
              const date = e.target.value
                ? UTCToLocalDate(e.target.value)
                : undefined;

              setOrder((o) => ({
                ...o!,
                survey_date: date,
              }));
            }}
          />
        </div>
        <div className="">
          <div className=" mb-1 font-semibold text-xs">SLD & BOQ date</div>
          <input
            className={`w-full text-xs  px-3 py-2  bg-gray-100 rounded focus:outline-none`}
            id="order-create-detail-sld-boq-date"
            type="date"
            name="sld_and_boq_date"
            required
            value={
              order.sld_and_boq_date &&
              moment(order.sld_and_boq_date).format("YYYY-MM-DD")
            }
            onChange={(e) => {
              const date = e.target.value
                ? UTCToLocalDate(e.target.value)
                : undefined;

              setOrder((o) => ({
                ...o!,
                sld_and_boq_date: date,
              }));
            }}
          />
        </div>
        <div className="">
          <div className=" mb-1 font-semibold text-xs">
            SLD & BOQ approval date
          </div>
          <input
            className={`w-full text-xs  px-3 py-2  bg-gray-100 rounded focus:outline-none`}
            id="order-create-detail-sld-boq-approval-date"
            type="date"
            name="sld_and_boq_approval_date"
            required
            value={
              order.sld_and_boq_approval_date &&
              moment(order.sld_and_boq_approval_date).format("YYYY-MM-DD")
            }
            onChange={(e) => {
              const date = e.target.value
                ? UTCToLocalDate(e.target.value)
                : undefined;

              setOrder((o) => ({
                ...o!,
                sld_and_boq_approval_date: date,
              }));
            }}
          />
        </div>
        <div className="">
          <div className=" mb-1 font-semibold text-xs">Installation date</div>
          <input
            className={`w-full text-xs  px-3 py-2  bg-gray-100 rounded focus:outline-none`}
            id="order-create-detail-installation-date"
            type="date"
            name="installation_date"
            required
            value={
              order.installation_date &&
              moment(order.installation_date).format("YYYY-MM-DD")
            }
            onChange={(e) => {
              const date = e.target.value
                ? UTCToLocalDate(e.target.value)
                : undefined;

              setOrder((o) => ({
                ...o!,
                installation_date: date,
              }));
            }}
          />
        </div>
        <div className="">
          <div className=" mb-1 font-semibold text-xs">Commission date</div>
          <input
            className={`w-full text-xs  px-3 py-2  bg-gray-100 rounded focus:outline-none`}
            id="order-create-detail-commission-date"
            type="date"
            name="commission_date"
            required
            value={
              order.commission_date &&
              moment(order.commission_date).format("YYYY-MM-DD")
            }
            onChange={(e) => {
              const date = e.target.value
                ? UTCToLocalDate(e.target.value)
                : undefined;

              setOrder((o) => ({
                ...o!,
                commission_date: date,
              }));
            }}
          />
        </div>
        <div className="">
          <div className=" mb-1 font-semibold text-xs">Dealer code</div>
          <input
            className={`w-full text-xs  px-3 py-2  bg-gray-100 rounded focus:outline-none`}
            id="order-create-detail-dealer-code"
            type="string"
            name="dealer_code"
            required
            value={order.dealer_code}
            onChange={(e) => {
              setOrder((o) => ({
                ...o!,
                dealer_code: e.target.value,
              }));
            }}
          />
        </div>
      </div>
    </>
  );
};

export default OrderDetailSection;
